<template>
  <div class="w-full">
    <div
      class="relative flex items-end gap-2 w-full"
      @drop.prevent="handleDrop"
      @dragover.prevent="isDragOver = true"
      @dragleave="isDragOver = false"
      @dragenter.prevent
    >
      <Transition
        enter-active-class="transition-opacity duration-150 ease-out"
        leave-active-class="transition-opacity duration-150 ease-out"
        enter-from-class="opacity-0"
        leave-to-class="opacity-0"
      >
        <div
          v-if="isDragOver"
          class="absolute inset-0 z-10 flex items-center justify-center rounded-2xl bg-nera-accent-light/95 border-2 border-dashed border-nera-accent pointer-events-none"
        >
          <div class="text-center text-nera-accent">
            <i class="fas fa-cloud-upload-alt text-3xl mb-2 block"></i>
            <p class="font-semibold">Drop file to upload</p>
          </div>
        </div>
      </Transition>

      <div class="relative flex-1">
        <textarea
          v-model="messageText"
          @keydown.enter.exact.prevent="handleSend"
          :disabled="disabled"
          placeholder="How can I assist you?"
          rows="1"
          ref="textareaRef"
          id="main-chat-input"
          class="w-full min-h-11 max-h-[200px] resize-none py-3 pr-14 bg-transparent text-nera-text text-base border-0 placeholder:text-nera-muted focus:outline-none disabled:opacity-60"
        ></textarea>
        <button
          @click="handleSend"
          :disabled="!canSend"
          :title="canSend ? 'Send message' : 'Type a message to send'"
          aria-label="Send message"
          :class="[
            'absolute right-2 bottom-1.5 w-9 h-9 inline-flex items-center justify-center rounded-full border-0 transition-all',
            canSend
              ? 'bg-nera-accent text-white shadow-sm cursor-pointer hover:bg-nera-accent-hover hover:shadow-md'
              : 'bg-nera-elevated-3 text-nera-muted cursor-not-allowed'
          ]"
        >
          <i class="fas fa-paper-plane text-sm"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, watch, nextTick } from 'vue'

const props = defineProps({
  disabled: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['send', 'file-dropped'])

const messageText = ref('')
const textareaRef = ref(null)
const isDragOver = ref(false)

const canSend = computed(() => messageText.value.trim().length > 0 && !props.disabled)

const handleSend = () => {
  if (!canSend.value) return

  emit('send', messageText.value.trim())
  messageText.value = ''

  nextTick(() => {
    if (textareaRef.value) {
      textareaRef.value.style.height = 'auto'
    }
  })
}

const handleDrop = (e) => {
  isDragOver.value = false
  const file = e.dataTransfer.files[0]
  if (file) {
    emit('file-dropped', file)
  }
}

watch(messageText, () => {
  nextTick(() => {
    if (textareaRef.value) {
      textareaRef.value.style.height = 'auto'
      textareaRef.value.style.height = `${textareaRef.value.scrollHeight}px`
    }
  })
})
</script>
